module.exports = __webpack_public_path__ + "static/childcouncil_card_img3@2x-0f556bc0c1f889db6b04529d8a533ea0.jpg";